export default "__VITE_ASSET__CTZaYYD___"